class TsProduct extends HTMLElement {
  constructor() {
    super();

    this.init();
    this.media = this.closest('.ts-product')
      .querySelectorAll('.ts-product-media .ts-gallery-thumbs img');

    this.galleryTop = null;
    this.galleryThumbs = null;

    this.upsell = this.querySelector('ts-upsell');
  }

  init() {
    this.setupVariantSelector();
    this.setupFormSubmit();
    this.initSlider();
  }

  initSlider() {
    const slides = document.querySelectorAll(
      '.ts-product .ts-gallery-thumbs .swiper-slide'
    );

    this.galleryThumbs = new Swiper('.ts-gallery-thumbs', {
      spaceBetween: 8,
      slidesPerView: 4,
      breakpoints: {
        1024: {
          direction: 'vertical',
        },
      },
    });

this.galleryTop = new Swiper('.ts-gallery', {
  spaceBetween: 1,
  autoHeight: true,
  loop: true,          // ← ADD THIS

  navigation:
    slides.length > 2
      ? {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        }
      : false,

  thumbs: {
    swiper: this.galleryThumbs,
  },

  on: {
    init: () => {
      this.setupGalleryFeatures();
    },
    slideChange: () => {
      this.updateZoomImage();
    },
  },
});

    if (slides.length <= 2) {
      document
        .querySelector('.swiper-button-next')
        ?.style.setProperty('display', 'none');

      document
        .querySelector('.swiper-button-prev')
        ?.style.setProperty('display', 'none');
    }
  }

  // -----------------------------
  // GALLERY FEATURES (ZOOM + CLICK)
  // -----------------------------
  setupGalleryFeatures() {
    const gallery = document.querySelector('.ts-gallery');

    if (!gallery || gallery.dataset.featuresInit) return;
    gallery.dataset.featuresInit = 'true';

    // CLICK -> NEXT IMAGE
    gallery.addEventListener('click', () => {
      this.galleryTop?.slideNext();
    });

    // ZOOM BUTTON
    const zoomBtn = document.createElement('button');
    zoomBtn.className = 'zoom-btn';

    zoomBtn.innerHTML = `
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" 
        stroke="currentColor" stroke-width="2">
        <circle cx="11" cy="11" r="7"></circle>
        <line x1="16.5" y1="16.5" x2="21" y2="21"></line>
      </svg>
    `;

    gallery.style.position = 'relative';
    gallery.appendChild(zoomBtn);

    zoomBtn.addEventListener('click', (e) => {
      e.stopPropagation();

      const activeImg = gallery.querySelector('.swiper-slide-active');

      if (activeImg?.src) {
        // Strip Shopify size suffix (e.g. _480x480, _1024x1024) to get the original full-size image
        const fullSrc = activeImg.src.replace(/_\d+x\d*\.(jpg|jpeg|png|webp)/i, '.$1');
        this.openLightbox(fullSrc);
      }
    });
  }

  // -----------------------------
  // LIGHTBOX
  // -----------------------------
  openLightbox(src) {
    if (!document.getElementById('ts-lightbox-style')) {
      const style = document.createElement('style');
      style.id = 'ts-lightbox-style';
      style.textContent = `
        @keyframes tsLightboxFadeIn { from { opacity: 0 } to { opacity: 1 } }
        @keyframes tsLightboxScaleIn { from { transform: scale(0.92); opacity: 0 } to { transform: scale(1); opacity: 1 } }
      `;
      document.head.appendChild(style);
    }

    const overlay = document.createElement('div');
    overlay.style.cssText = `
      position: fixed;
      inset: 0;
      background: rgba(0,0,0,0.92);
      display: flex;
      align-items: center;
      justify-content: center;
      z-index: 9999;
      cursor: zoom-out;
      animation: tsLightboxFadeIn 0.2s ease;
    `;

    const img = document.createElement('img');
    img.src = src;
    img.style.cssText = `
      max-width: 90vw;
      max-height: 90vh;
      object-fit: contain;
      border-radius: 4px;
      box-shadow: 0 8px 40px rgba(0,0,0,0.6);
      cursor: default;
      animation: tsLightboxScaleIn 0.25s ease;
    `;

    const closeBtn = document.createElement('button');
    closeBtn.innerHTML = `
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none"
        stroke="white" stroke-width="2">
        <line x1="18" y1="6" x2="6" y2="18"></line>
        <line x1="6" y1="6" x2="18" y2="18"></line>
      </svg>
    `;
    closeBtn.style.cssText = `
      position: fixed;
      top: 20px;
      right: 20px;
      background: rgba(255,255,255,0.15);
      border: none;
      border-radius: 50%;
      width: 44px;
      height: 44px;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      transition: background 0.2s;
    `;

    closeBtn.addEventListener('mouseenter', () => {
      closeBtn.style.background = 'rgba(255,255,255,0.3)';
    });
    closeBtn.addEventListener('mouseleave', () => {
      closeBtn.style.background = 'rgba(255,255,255,0.15)';
    });

    const close = () => {
      overlay.style.opacity = '0';
      overlay.style.transition = 'opacity 0.2s';
      setTimeout(() => overlay.remove(), 200);
      document.removeEventListener('keydown', onKeydown);
    };

    const onKeydown = (e) => {
      if (e.key === 'Escape') close();
    };

    overlay.addEventListener('click', close);
    img.addEventListener('click', (e) => e.stopPropagation());
    closeBtn.addEventListener('click', close);
    document.addEventListener('keydown', onKeydown);

    overlay.appendChild(img);
    overlay.appendChild(closeBtn);
    document.body.appendChild(overlay);
  }

  updateZoomImage() {
    // optional future use (e.g. lightbox sync)
  }

  // -----------------------------
  // VARIANTS
  // -----------------------------
  setupVariantSelector() {
    const optionInputs = this.querySelectorAll(
      '.ts-options input[type="radio"]'
    );

    const productIdInput = this.querySelector('input[name="id[]"]');

    if (!productIdInput) return;

    const variantDataScript = this.querySelector('#ProductVariants');
    if (!variantDataScript) return;

    const variants = JSON.parse(variantDataScript.textContent);

    optionInputs.forEach((input) => {
      input.addEventListener('change', () => {
        this.updateVariant(productIdInput, variants);
      });
    });
  }

  updateVariant(productIdInput, variants) {
    const selectedOptions = [];

    this.querySelectorAll('.ts-options fieldset').forEach((fieldset) => {
      const selectedInput = fieldset.querySelector('input:checked');
      if (selectedInput) {
        selectedOptions.push(selectedInput.value);
      }
    });

    const matchedVariant = variants.find((variant) =>
      variant.options.every(
        (opt, index) => opt === selectedOptions[index]
      )
    );

    if (!matchedVariant) return;

    const matchedUrl = new URL(
      matchedVariant.featured_image.src,
      window.location.origin
    );

    Array.from(this.media).forEach((img, index) => {
      const imgUrl = new URL(img.src, window.location.origin);

      if (imgUrl.pathname === matchedUrl.pathname) {
        this.galleryTop?.slideTo(index);
      }
    });

    productIdInput.value = matchedVariant.id;
    this.updatePrice(matchedVariant);
  }

  updatePrice(matchedVariant) {
    const priceEl = this.querySelector('.ts-money');

    if (!priceEl) return;

    priceEl.innerHTML = Shopify.formatMoney(
      matchedVariant.price
    ).replace('€', '€ ');
  }

  // -----------------------------
  // ADD TO CART
  // -----------------------------
  setupFormSubmit() {
    const form = this.querySelector('form');
    const addBtn = this.querySelector('.ts-add');
    const cartDrawer = document.querySelector('cart-notification');

    if (!form) return;

    form.addEventListener('submit', (event) => {
      event.preventDefault();

      addBtn?.classList.add('active');

      const formData = new FormData(form);

      if (cartDrawer?.cartType !== 'page') {
        formData.append(
          'sections',
          cartDrawer.getSectionsToRender().map((s) => s.id)
        );

        formData.append(
          'sections_url',
          window.location.pathname
        );

        cartDrawer.setActiveElement(document.activeElement);
      }

      fetch('/cart/add.js', {
        method: 'POST',
        body: formData,
      })
        .then((res) => res.json())
        .then((response) => {
          cartDrawer?.renderContents(response);
          this.upsell?.rerenderUpsell();
        });
    });
  }
}

customElements.define('ts-product', TsProduct);